interface Props {
  [key: string]: any
}

export default function HomPhoneIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props

  return (
    <svg fill="none" viewBox="0 0 12 12" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.30935 1.00467C1.30935 1.00467 1.2166 2.09346 1.64127 2.94658C2.06594 3.79971 3.23523 5.55438 3.69606 5.26008C3.47906 4.9725 3.6246 4.64875 3.78794 4.49096C3.89381 4.38858 4.39081 3.919 4.72681 3.60167C4.91348 3.4255 4.95752 3.14579 4.83414 2.92063L3.64502 0.751209C3.5161 0.515834 3.23931 0.404125 2.98323 0.48375L1.30935 1.00467Z"
        fill="#7D38D6"
      />
      <path
        d="M10.9953 10.69C10.9953 10.69 9.90655 10.7827 9.05342 10.3581C8.2003 9.9334 6.44563 8.7641 6.73992 8.30327C7.0275 8.52027 7.35125 8.37473 7.50905 8.2114C7.61142 8.10552 8.081 7.60852 8.39834 7.27252C8.5745 7.08585 8.85421 7.04181 9.07938 7.16519L11.2488 8.35431C11.4842 8.48323 11.5959 8.76002 11.5163 9.0161L10.9953 10.69Z"
        fill="#7D38D6"
      />
      <path
        d="M5.12166 6.8791C6.84716 8.6046 8.85587 9.86926 10.9964 10.6897L10.6843 11.2287C10.5315 11.4927 10.208 11.6117 9.92454 11.4991C7.85604 10.6769 5.91675 9.43147 4.24287 7.75789C2.569 6.0843 1.32358 4.14472 0.501371 2.07622C0.388788 1.79301 0.507788 1.46956 0.771746 1.31672L1.31075 1.00464C2.1315 3.14489 3.39616 5.15389 5.12166 6.8791Z"
        fill="#A37DD5"
      />
    </svg>
  )
}
